import * as React from 'react';
import { UIBasic, IPropsBasic } from 'kts-scaffold-framework/modules';
import { connect } from 'kts-platform-frame/redux';
import ReduxState, { } from 'kts-platform-frame/redux/ReduxState';
import ModulesState from './Modules.State';
import ModulesAction from './Modules.Action';
import { history } from 'kts-platform-frame/routes';
import { Button } from 'antd';
const css = require('./index.scss');
import {
    Modal
} from 'antd';
const confirm = Modal.confirm;

/** Redux接口 */
interface IReduxStatePart {
    
}

/** Props接口 */
interface IProps extends IReduxStatePart, IPropsBasic {

}

/** 绑定全局数据到props */
@ModulesAction.uiconnect
@connect((state: ReduxState): IReduxStatePart => ({

}))
export default class UIComponents extends UIBasic<IProps, ModulesState> {

    constructor(props: IProps) {
        super(props, ModulesAction);
    }


    render() {
        return (
            <div className={css['group-header']}>
                <h1>发票组详情</h1>
                <Button className={css['group-header-return']} onClick={this.closeConfirm}>返回</Button>
            </div>
        );
    }

    private closeConfirm = (): void => {
        const groupId = this.props.match.params.id;
        if (this.modulesState.recover) {
            const that = this;
            confirm({
                title: '关闭',
                content: '关闭后修改的内容将丢失，是否保存？',
                cancelText: '不保存',
                okText: '保存',
                onOk() {
                    ModulesAction.groupSaveDetail(groupId);
                    ModulesAction.groupInfo(groupId);
                    that.historyJump();
                },
                onCancel() {
                    that.historyJump();
                }
            });
        } else {
            this.historyJump();
        }
    }

    private historyJump = () => {
        history.goBack();
    }
}


// WEBPACK FOOTER //
// ./src/display/apps/InvoiceInput/Group/UI.Header.tsx